import find from 'lodash/find';
import updateBoardDataInFirebase from './../../helpers/updateBoardDataInFirebase';

const namespaced = true;

const state = {
  boards: [],
};

const getters = {
  getBoards: state => {
    return state.boards;
  },
};

const mutations = {
  SET_BOARDS_DATA_FROM_FIREBASE_MUTATION: (state, payload) => {
    state.boards = payload;
  },
  TOGGLE_PROMOTE_BOARD_MUTATION: (state, payload) => {
    const board = find(state.boards, {boardId: payload.boardId});
    board.promoted = !board.promoted;
    updateBoardDataInFirebase(payload.boardId, {promoted: board.promoted});
  },
};

const actions = {
  SET_BOARDS_DATA_FROM_FIREBASE_ACTION: ({commit, state}, payload) => {
    commit('SET_BOARDS_DATA_FROM_FIREBASE_MUTATION', payload);
  },
  TOGGLE_PROMOTE_BOARD_ACTION: ({commit, state}, payload) => {
    commit('TOGGLE_PROMOTE_BOARD_MUTATION', payload);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
